import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { withResizeDetector } from 'react-resize-detector';
import { useHistory, useLocation } from 'react-router-dom';

import { ActionsDropdownForGroup } from '../../components/base/ActionsDropdown';
import CountComponent from '../../components/base/CountComponent';
import { ImageTextButton } from '../../components/base/CustomImageButton';
import ListFilterComponent from '../../components/base/ListFilterComponent';

import { getNearbyUpdateTime } from 'utils/TimeFormatUtil';

import filterImage from '../../assets/images/32filter.svg';
import CustomTips from 'components/base/CustomTips';

export const CustomerDefaultCautionDetail = (
  <div>
    Search by
    <ul>
      <li>Name</li>
      <li>Membership ID</li>
      <li>Mobile number</li>
      <li>Email</li>
    </ul>
  </div>
)

const TabContainer = ({
  width,
  maxTabWidth = 0,
  tabs,
  activeTab,
  listContent,
  onSelect,
}) => {
  let tabShown = true;
  if (tabShown && maxTabWidth > 0 && width - 440 < maxTabWidth) {
    tabShown = false;
  }
  return (
    <Tabs
      activeKey={activeTab}
      onSelect={onSelect}
      className={`campaign-list-tab-container ${tabShown ? '' : 'hide-tab-bar'
        }`}
    >
      {tabs.map((config, index) => {
        // console.log(config.key === activeTab);
        return (
          <Tab
            key={`${index}-${config.key}`}
            eventKey={config.key}
            title={config.name}
          >
            {config.key === activeTab ? (
              listContent
            ) : (
              <div>
                {config.key} - {activeTab}
              </div>
            )}
          </Tab>
        );
      })}
    </Tabs>
  );
};
const TabContainerWithSize = withResizeDetector(TabContainer);

function BaseTabListContainer({
  maxTabWidth = 0,
  hideTab,
  groupActions,
  tabs,
  pageInfo,
  totalCount,
  listContent,
  defaultTabKey,
  hideSearch,
  searchPlaceholder,
  useCaution,
  cautionDetail,
  // showDeletePrompt,
  filter = {},
  tabSearchKey,
  showLastUpdateTime,
}) {
  const history = useHistory();
  const location = useLocation();

  const queryString = require('query-string');
  const tabKey = tabSearchKey || 'type';
  const [activeTab, setActiveTab] = useState(
    queryString.parse(location.search)[tabKey] || 'all',
  );
  // const [searchKey, setSearchKey] = useState();
  const [showFilter, setShowFilter] = useState(false);

  const getFilterCount = () => {
    let filterCount = 0;
    const querySearch = queryString.parse(location.search);
    Object.entries(querySearch).map(([key, value]) => {
      if (Object.keys(querySearch).includes(querySearch[key])) {
        return null;
      }
      if (!['page', 'rank', 'search', 'sort'].includes(key) && value) {
        if (
          (key === tabKey && value.toLowerCase().indexOf('all') < 0) ||
          key !== tabKey
        )
          filterCount += 1;
      }
      return null;
    });

    return filterCount;
  };

  useEffect(() => {
    const searchTab = queryString.parse(location.search)[tabKey];
    if (tabs?.filter((tab) => tab.key === searchTab)?.length > 0) {
      if (defaultTabKey) {
        setActiveTab(searchTab || defaultTabKey);
      } else {
        setActiveTab(searchTab || 'all');
      }
    } else {
      setActiveTab(defaultTabKey || 'all');
    }

    // setSearchKey(queryString.parse(location.search)['search']);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const filterCount = getFilterCount();

  useEffect(() => {
    if (defaultTabKey) {
      setActiveTab(defaultTabKey);
    }
  }, [defaultTabKey, tabs]);
  //   useEffect(() => {
  //     setShowPrompt(showDeletePrompt);
  //   }, [showDeletePrompt]);

  return (
    <>
      {showFilter ? (
        <filter.component
          {...(filter.extraProperties || {})}
          backAction={() => setShowFilter(false)}
          displayIn={filter?.displayIn}
        />
      ) : null}
      <div className="all-list-scrollable-area" key={''}>
        <div id="tabindex" className="all-list-component-action-header">
          <div className="all-list-component-action-header-div">
            {groupActions?.length > 0 ? (
              <ActionsDropdownForGroup actions={groupActions} />
            ) : null}
            <CountComponent
              start={pageInfo?.startCursor || 0}
              end={pageInfo?.endCursor || 0}
              total={totalCount}
            />
          </div>
          {showLastUpdateTime ? (
            <div className="all-list-last-update-time-div">
              <label className="all-list-last-update-time-label">
                Last update time: {getNearbyUpdateTime()}
              </label>
            </div>
          ) : null}
        </div>

        {/* <EarningruleListData tabs={tabs} /> */}
        <div className="all-list-table-content">
          {hideTab ? (
            <div>
              <nav className="campaign-list-tab-container nav nav-tabs" />
              {listContent}
            </div>
          ) : (
            <TabContainerWithSize
              tabs={tabs}
              activeTab={activeTab}
              maxTabWidth={maxTabWidth}
              listContent={listContent}
              onSelect={(key) => {
                const queryData = {
                  search: '',
                  page: 1,
                  rank: true,
                };
                if (key !== 'all') {
                  queryData[tabKey] = key;
                }
                history.push({
                  pathname: location.pathname,
                  hash: location.hash,
                  search: queryString.stringify(queryData),
                });
                setActiveTab(key);
              }}
            />
          )}
        </div>

        {filter.hasFilter ? (
          <div className="all-list-filter-container">
            <ImageTextButton
              action={() => setShowFilter(!showFilter)}
              image={filterImage}
              title={'Filter'}
            />
            {filterCount > 0 ? (
              <label className="filter-badge-icon">{filterCount}</label>
            ) : null}
          </div>
        ) : null}

        {hideSearch ? null : (
          <div className="all-list-search-container">
            <ListFilterComponent
              // defaultValue={searchKey}
              searchPlaceholder={searchPlaceholder}
              onSearch={(key) => {
                history.push({
                  pathname: location.pathname,
                  hash: location.hash,
                  search: queryString.stringify({
                    ...queryString.parse(location.search),
                    ...{ search: key, page: 1 },
                  }),
                });
              }}
              customClass={useCaution ? "list-filter-list-search-section-use-caution" : ""}
            />
            {
              useCaution && (
                <CustomTips
                  detail={cautionDetail}
                  placement="bottom"
                  popoverClassName="list-filter-list-search-section-popover"
                />
              )
            }
          </div>
        )}
      </div>
    </>
  );
}

export default BaseTabListContainer;
